module.exports = __webpack_public_path__ + "img/black.f9074fff.jpeg";